<template>
  <div :class="[`o-feed-section-info o-feed-section-info-${section}`,
      ($store.getters.getAcademyData.persona === undefined && $store.getters.getAcademyData.is_licencia_paga) ||
      ($store.getters.getAcademyDaysLeft !== null && !$store.getters.getAcademyData.is_licencia_paga)
        ? 'o-feed-section-info-upgrade' : ''
    ]">
    <span class="m-feed-section-info-menu">
      <span class="section-icon">
        <i :class="[`${iconClass}`, 'margin-right-medium']"></i>
      </span>
      <span class="margin-right-small">
        {{ $t(`oFeedSectionInfo.${$route.meta.isEdition}`) }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'OrganismFeedSectionInfo',

  data () {
    return {
      sectionIcons: {
        products: 'fas fa-box-open',
        projects: 'fas fa-folder-open'
      }
    }
  },

  computed: {
    iconClass () {
      return this.sectionIcons[this.$route.meta.isEdition]
    },

    section () {
      return this.$route.meta.isEdition
    }
  }
}
</script>
